import { Box } from '@stenajs-webui/core';
import { FlatButton, PrimaryButton } from '@stenajs-webui/elements';
import { ModalFooter } from '@stenajs-webui/modal';
import type { FC, ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  loading: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const SwitchModalFooter: FC<Props> = ({ loading, onClose, onSubmit, children }) => {
  return (
    <ModalFooter sticky>
      <Box flex={1}>{children}</Box>
      <Box flexDirection={['column', 'row']} justifyContent={'flex-end'} gap flex={1}>
        <FlatButton onClick={onClose} label={'Close'} />
        <PrimaryButton
          label="Switch"
          loading={loading}
          loadingLabel={'Switching...'}
          onClick={onSubmit}
        />
      </Box>
    </ModalFooter>
  );
};
